
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import SearchFilters from "./ContentDiscoveryPage.vue";
  
const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.vue-content-discovery-page', SearchFilters, {
  jsonProps: ['pagePurpose', 'pageTaxonomy'],
  beforeMount: (el, props) => { },
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});